import React, { useState, useEffect } from 'react';
import { bool, node } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';
import { Form, Button, FieldTextInput, PrimaryButton, FieldMultipleItems } from '../../../components';

import css from './SignupForm.module.css';
import { userTypes } from '../../../util/userTypes';
import FieldChipsGroup from '../../../components/FieldChipsGroup/FieldChipsGroup';
import FieldChipsMultipleItems from '../../../components/FieldChipsMultipleItemsSelect/FieldChipsMultipleItemsSelect';

const SignupFormComponent = props => {
  const { signupKind } = props;

  // const [userTypeShopper, setUserTypeShopper] = useState(false);
  // const [userTypeShopAndBrand, setUserTypeShopAndBrand] = useState(false);

  useEffect(() => {
    if (signupKind) {
      // setUserTypeShopAndBrand(true);
    }
  }, [signupKind]);

  return (
    <FinalForm
      {...props}
      initialValues={signupKind ? { userType: signupKind } : null}
      mutators={{ ...arrayMutators }}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          formId,
          handleSubmit,
          inProgress,
          invalid,
          intl,
          termsAndConditions,
          values,
          form,
        } = fieldRenderProps;

        // email validators
        const emailRequired = validators.required(
          intl.formatMessage({
            id: 'SignupForm.emailRequired',
          })
        );
        const emailValid = validators.emailFormatValid(
          intl.formatMessage({
            id: 'SignupForm.emailInvalid',
          })
        );

        // password validators
        const passwordRequiredMessage = intl.formatMessage({
          id: 'SignupForm.passwordRequired',
        });
        const passwordMinLengthMessage = intl.formatMessage(
          {
            id: 'SignupForm.passwordTooShort',
          },
          {
            minLength: validators.PASSWORD_MIN_LENGTH,
          }
        );
        const passwordMaxLengthMessage = intl.formatMessage(
          {
            id: 'SignupForm.passwordTooLong',
          },
          {
            maxLength: validators.PASSWORD_MAX_LENGTH,
          }
        );
        const passwordMinLength = validators.minLength(
          passwordMinLengthMessage,
          validators.PASSWORD_MIN_LENGTH
        );
        const passwordMaxLength = validators.maxLength(
          passwordMaxLengthMessage,
          validators.PASSWORD_MAX_LENGTH
        );
        const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);
        const passwordValidators = validators.composeValidators(
          passwordRequired,
          passwordMinLength,
          passwordMaxLength
        );

        const classes = classNames(rootClassName || css.root, className);
        const submitInProgress = inProgress;
        const submitDisabled = invalid || submitInProgress;

        const handleClick = buttonName => {
          if (buttonName === userTypes.shopper) {
            setUserTypeShopper(!userTypeShopper)
          } else if (buttonName === userTypes.shopsAndBrands) {
            setUserTypeShopAndBrand(!userTypeShopAndBrand);
          }
        };

        console.log({ values });

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <div>
              <FieldTextInput
                type="email"
                id={formId ? `${formId}.email` : 'email'}
                name="email"
                autoComplete="email"
                label={intl.formatMessage({
                  id: 'SignupForm.emailLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'SignupForm.emailPlaceholder',
                })}
                validate={validators.composeValidators(emailRequired, emailValid)}
                displayColumn
              />
              <div className={css.name}>
                <FieldTextInput
                  rootClassName={css.firstNameRoot}
                  type="text"
                  id={formId ? `${formId}.fname` : 'fname'}
                  name="fname"
                  autoComplete="given-name"
                  label={intl.formatMessage({
                    id: 'SignupForm.firstNameLabel',
                  })}
                  placeholder={intl.formatMessage({
                    id: 'SignupForm.firstNamePlaceholder',
                  })}
                  validate={validators.required(
                    intl.formatMessage({
                      id: 'SignupForm.firstNameRequired',
                    })
                  )}
                  displayColumn
                />
                <FieldTextInput
                  rootClassName={css.lastNameRoot}
                  type="text"
                  id={formId ? `${formId}.lname` : 'lname'}
                  name="lname"
                  autoComplete="family-name"
                  label={intl.formatMessage({
                    id: 'SignupForm.lastNameLabel',
                  })}
                  placeholder={intl.formatMessage({
                    id: 'SignupForm.lastNamePlaceholder',
                  })}
                  validate={validators.required(
                    intl.formatMessage({
                      id: 'SignupForm.lastNameRequired',
                    })
                  )}
                  displayColumn
                />
              </div>

              {/*<div className={css.name}>*/}
              {/*  <FieldChipsMultipleItems*/}
              {/*    id={`${formId}userType`}*/}
              {/*    name='userType'*/}
              {/*    className={css.filedClass}*/}
              {/*    displayColumn*/}
              {/*    label={intl.formatMessage({ id: 'SignupForm.registerAs' })}*/}
              {/*    options={*/}
              {/*      [*/}
              {/*        { option: userTypes.shopsAndBrands, label: intl.formatMessage({ id: 'UserType.shopsAndBrands' }) },*/}
              {/*        { option: userTypes.shopper, label: intl.formatMessage({ id: 'UserType.shopper' }) },*/}
              {/*      ]*/}
              {/*    }*/}
              {/*    validate={validators.requiredFieldArrayCheckbox(intl.formatMessage({ id: 'SignupForm.registerAsRequired' }))}*/}
              {/*  />*/}
              {/*</div>*/}

              <FieldTextInput
                className={css.password}
                type="password"
                id={formId ? `${formId}.password` : 'password'}
                name="password"
                autoComplete="new-password"
                label={intl.formatMessage({
                  id: 'SignupForm.passwordLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'SignupForm.passwordPlaceholder',
                })}
                validate={passwordValidators}
                displayColumn
              />
            </div>

            <div className={css.bottomWrapper}>
              {termsAndConditions}
              <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
                <FormattedMessage id="SignupForm.signUp" />
              </PrimaryButton>
            </div>
          </Form>
        );
      }}
    />
  );
};

SignupFormComponent.defaultProps = { inProgress: false };

SignupFormComponent.propTypes = {
  inProgress: bool,
  termsAndConditions: node.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SignupForm = compose(injectIntl)(SignupFormComponent);
SignupForm.displayName = 'SignupForm';

export default SignupForm;
